// @ts-nocheck
import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Actions from '../../../../actions'
import Operations from '../../../../operations'
import { Link } from 'react-router-dom'
import Form from '../..'
import ConfirmationDialog from '../../../../LEGACY/ConfirmationDialog'
import { colors, sizes } from '@lmc/common/constants'
import { getNominative } from '../../../../common/utils'
import {
  AccessRestriction,
  AvatarUpload,
  ErrorBox,
  Icon,
  ProfilePicture,
} from '../../../generic'
import Field from '../../../fields'
import ResidentPrimaryInfo from './ResidentPrimaryInfo'
import ResidentPersonalInfo from './ResidentPersonalInfo'
import ResidentOtherDetails from './ResidentOtherDetails'
import ResidentImportantContacts from './ResidentImportantContacts'

import { isBrowser, isTablet } from 'react-device-detect'
import { Button } from '@lmc/ui-kit'
import Glyph from '../../../../LEGACY/Glyph'
import { Badge } from '@lmc/ui-kit'
import { history } from '../../../../store'

export class ResidentEditForm extends React.Component {
  state = {
    deleteDialogOpen: false,
    imageUploadOpen: false,
  }

  formRef = null

  setFormRef = (node) => (this.formRef = node)

  componentDidMount() {
    this.props.fetchList('gps')
  }

  handleCancel = () => {
    const { fields, remove, router } = this.props
    const { id } = fields
    remove({
      onConfirm: () => history.push(`/residents/${id}/profile`),
    })
  }

  handleComplete = (resident) => {
    const { fetchList, router, showToast, preferredPeopleNominative } =
      this.props
    showToast({
      title: `Updated a ${getNominative(
        preferredPeopleNominative,
        'Resident'
      )}`,
    })
    fetchList('residents')
    history.push(`/residents/${resident.id}/profile`)
  }

  handleDelete = () => {
    const { deleteSelf, fields, router, showToast, preferredPeopleNominative } =
      this.props
    deleteSelf({
      id: fields.id,
      onComplete: () => {
        showToast({
          type: 'info',
          title: `Deleted a ${getNominative(
            preferredPeopleNominative,
            'Resident'
          )}`,
        })
        history.push(`/residents`)
      },
    })
  }

  handleDeleteContact = ({ key, indexes }) => {
    const { clearFormArray, showToast } = this.props
    clearFormArray({ key, indexes })
    showToast({ type: 'info', title: 'Deleted an Important Contact' })
  }

  handleImageSave = (file, imageUri) => {
    this.props.addFormFile({ key: 'picture', file, uri: imageUri })
  }

  handleSubmit = () => {
    const { fields, updateItem, setFormField } = this.props
    if (fields.zone === 'Unassigned') {
      setFormField({ key: 'zone', value: null })
    }
    updateItem({
      url: `list/residents/${fields.id}`,
      onComplete: this.handleComplete,
      onError: () => {
        if (this.formRef) {
          this.formRef?.scrollIntoView({ behavior: 'smooth' })
        }
      },
    })
  }

  renderMainContent = (fields, isDummy) => (
    <div>
      <div
        className="lmc-card"
        style={{
          ...styles.sectionContainer,
          ...styles.primaryInfoContainer,
        }}
      >
        {isDummy && (
          <Badge
            color={colors.orange}
            style={styles.dummyBadge}
            textColor={colors.white}
            text="Example"
          />
        )}
        {this.renderPrimaryFields(fields)}
        <div style={styles.divider} />
        {this.renderLocationFields(fields)}
        <div style={styles.divider} />
        {this.renderSummaryField(fields)}
      </div>
      {this.renderCarePlansFields(fields)}
      {this.renderImportantContacts(fields)}
    </div>
  )

  renderPrimaryFields = (fields) => {
    const {
      carers,
      errors,
      features,
      zones,
      preferredPeopleNominative,
      profile,
      user,
    } = this.props
    return (
      <div style={styles.fieldsContainer}>
        <div style={styles.requiredText}>
          Required fields are marked with{' '}
          <span style={{ color: colors.red, fontWeight: 600 }}>*</span>
        </div>
        <ErrorBox errors={errors} style={{ marginBottom: 10 }} />
        <ResidentPrimaryInfo
          data={{ carers, features, zones }}
          fields={fields}
          formId={FORM_ID}
          preferredPeopleNominative={preferredPeopleNominative}
          profile={profile}
          user={user}
        />
      </div>
    )
  }

  renderLocationFields = (fields) => {
    const labels = ['building', 'floor', 'room', 'bed']
    return (
      <div style={styles.locationContainer}>
        {labels.map((label, i) => (
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              formId={FORM_ID}
              key={i}
              keys={`location.${label}`}
              label={label}
              type="bubble"
              values={fields}
            />
          </Suspense>
        ))}
      </div>
    )
  }

  renderSummaryField = (fields) => (
    <div style={styles.summaryContainer}>
      <div style={styles.summaryText}>
        <label htmlFor="form-summary" style={styles.summaryLabel}>
          Notes
        </label>
        <textarea
          value={fields.summary || ''}
          style={styles.summary}
          id="form-summary"
          className="FormInput"
          onChange={(e) =>
            this.props.setFormField({
              key: 'summary',
              value: e.target.value,
            })
          }
        />
        <span style={styles.summaryNote}>
          {getSummaryNote(this.props.preferredPeopleNominative)}
        </span>
      </div>
    </div>
  )

  renderPersonalDetails = (fields) => (
    <div
      className="lmc-card"
      style={{
        ...styles.sectionContainer,
        marginTop: '-10px',
      }}
    >
      <div style={styles.sectionHeaderContainer}>
        <div
          style={{
            ...styles.iconContainer,
            background: colors.purple,
          }}
        >
          <Icon name="profile" />
        </div>
        <div style={styles.sectionHeader}>Personal details</div>
      </div>
      <ResidentPersonalInfo
        fields={fields}
        formId={FORM_ID}
        style={styles.fieldsContainer}
      />
    </div>
  )

  renderMedicationListLink = (fields) => (
    <div style={styles.fieldsContainer}>
      <span className="important-contact-title" style={styles.smallTitle}>
        Medication
      </span>
      <Link to={`/residents/${fields.id}/profile/medications`}>
        Go to my Medication List{' '}
        <span className="octicon octicon-chevron-right" />
      </Link>
    </div>
  )

  renderCarePlansFields = (fields) => {
    // Render Personal Details, Care Related Information and Medications
    // A few fields are eMAR specific and need to be rendered even if Care Plans isn't enabled
    // Alleries should be shown for both eMAR and Care Plans
    const { features } = this.props
    if (!features.carePlans && !features.eMAR) return null
    return (
      <>
        {features.carePlans && this.renderPersonalDetails(fields)}
        <div className="lmc-card" style={styles.sectionContainer}>
          <div style={styles.sectionHeaderContainer}>
            <div
              style={{
                ...styles.iconContainer,
                background: colors.darkblue,
              }}
            >
              <Icon name="health-visit" />
            </div>
            <div style={styles.sectionHeader}>Care related information</div>
          </div>
          <ResidentOtherDetails
            fields={fields}
            formId={FORM_ID}
            style={styles.fieldsContainer}
            features={features}
          />
          <div style={styles.divider} />
          {features.features?.carePlanMeds?.enabled &&
            this.renderMedicationListLink(fields)}
        </div>
      </>
    )
  }

  renderImportantContacts = (fields) => {
    const { gps, setFormField, features } = this.props
    return (
      <div
        className="lmc-card"
        style={{
          ...styles.sectionContainer,
          marginTop: features.carePlans ? 60 : 0,
        }}
      >
        <div style={styles.sectionHeaderContainer}>
          <div
            style={{
              ...styles.iconContainer,
              background: colors.orange,
            }}
          >
            <Icon name="social" />
          </div>
          <div style={styles.sectionHeader}>Important people</div>
        </div>
        <ResidentImportantContacts
          fields={fields}
          family={features.family}
          familySetupComplete={features.familySetupComplete}
          formId={FORM_ID}
          gps={gps}
          onChange={setFormField}
          onDelete={this.handleDeleteContact}
          style={styles.fieldsContainer}
        />
      </div>
    )
  }

  renderFooter = (isSubmitting) => (
    <div
      className="lmc-fixed-footer"
      style={{
        ...styles.footer,
      }}
    >
      <div>
        <Button
          id="resident-delete"
          onClick={() => this.setState({ deleteDialogOpen: true })}
          style={styles.deleteButton}
          variant="danger"
          icon={<Glyph name="trashcan" />}
        >
          Delete Profile
        </Button>
      </div>
      <div style={styles.rowButton}>
        <Button
          className="resident-edit-cancel"
          onClick={this.handleCancel}
          style={styles.cancelButton}
          variant="secondary"
          icon={<Glyph name="x" />}
        >
          Cancel
        </Button>
        <Button
          className="resident-edit-save"
          loading={isSubmitting}
          onClick={this.handleSubmit}
          variant="primary"
          icon={<Glyph name="check" />}
          style={styles.saveButton}
        >
          Save
        </Button>
      </div>
    </div>
  )

  render() {
    const {
      features,
      fields,
      files,
      preferredPeopleNominative,
      isSubmitting,
      profile,
    } = this.props
    const { deleteDialogOpen, imageUploadOpen } = this.state

    const isDummy = profile?.status === 'dummy'

    if (!features || !fields) return null
    const isDesktop = isBrowser || isTablet
    const picture = files && files.picture ? files.picture.uri : fields.picture

    const firstName = fields.name?.first?.trim()
    const lastName = fields.name?.last?.trim()

    return (
      <AccessRestriction>
        <div ref={this.setFormRef}>
          <div
            style={{
              ...styles.wrapper,
              paddingTop: isDesktop ? 50 : null,
            }}
          >
            <ProfilePicture
              edit={!isDummy}
              onClick={
                !isDummy
                  ? () => this.setState({ imageUploadOpen: true })
                  : undefined
              }
              type="large"
              style={styles.image}
              url={picture}
            />
            {this.renderMainContent(fields, isDummy)}
          </div>
          {this.renderFooter(isSubmitting)}
          <ConfirmationDialog
            isOpen={deleteDialogOpen}
            onCancel={() => this.setState({ deleteDialogOpen: false })}
            onConfirmation={this.handleDelete}
            confirmationType="danger"
            title="YOU ARE DELETING A CLIENT PROFILE!"
            verificationText={`${firstName} ${lastName}`}
            finalConfirmationText={`Are you sure you want to permanently delete <strong>${firstName} ${lastName}</strong>?`}
            showFinalConfirmationStep
          >
            {ConfirmationBody(fields.name, preferredPeopleNominative)}
          </ConfirmationDialog>
          <AvatarUpload
            customButton
            isModalOpen={imageUploadOpen}
            onSave={this.handleImageSave}
            onClose={() => this.setState({ imageUploadOpen: false })}
          />
        </div>
      </AccessRestriction>
    )
  }
}

export const ConfirmationBody = (name, preferredPeopleNominative) => (
  <div>
    Are you sure you want to delete{' '}
    <strong>
      {name.first} {name.last}
    </strong>
    ? If you go ahead, it can’t be undone. Once the record is gone, it’s gone
    for good!
    <br />
    <br />
    {`Make sure you only click delete if you want to remove everything about this ${getNominative(
      preferredPeopleNominative,
      'resident'
    )}, including their profile, care logs, documents and To-Do’s.`}
  </div>
)

const getSummaryNote = (preferredPeopleNominative) =>
  `Useful information that will help your carers know more about the ${getNominative(
    preferredPeopleNominative,
    'resident'
  )} and how they like to be cared for. This summary will appear in the Carer App.`
const FORM_ID = 'editResident'

const styles = {
  cancelButton: {
    marginRight: 10,
  },
  deleteButton: {
    color: 'white',
  },
  dottedDivider: {
    borderBottom: '1px dashed',
    borderColor: colors.grey,
    height: 1,
    margin: 'auto',
    marginTop: 20,
    marginBottom: 20,
    width: '90%',
  },
  divider: {
    background: colors.grey,
    height: 1,
    margin: 'auto',
    marginTop: 20,
    marginBottom: 20,
    width: '90%',
    display: 'none',
  },
  image: {
    position: 'relative',
    zIndex: 1,
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
    minWidth: '60%',
    width: isBrowser || isTablet ? '60%' : '100%',
  },
  footer: {
    width: isBrowser || isTablet ? 'calc(100vw - 290px)' : '100vw',
  },
  iconContainer: {
    alignItems: 'center',
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: 1,
    height: 40,
    width: 40,
  },
  locationContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    margin: '0 auto',
    textAlign: 'center',
  },
  primaryInfoContainer: {
    marginTop: 0,
    paddingTop: 70,
    position: 'relative',
    bottom: 70,
  },
  requiredText: {
    margin: '10px 0px',
  },
  sectionContainer: {
    marginTop: 60,
    paddingBottom: 25,
  },
  sectionHeader: {
    alignSelf: 'flex-end',
    borderColor: colors.grey,
    fontSize: 24,
    flex: 1,
    marginLeft: 12,
  },
  sectionHeaderContainer: {
    display: 'flex',
    marginBottom: 20,
  },
  smallTitle: {
    display: 'block',
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 20,
  },
  summary: {
    minHeight: 130,
    height: '100%',
    minWidth: '100%',
    maxWidth: '100%',
  },
  summaryContainer: {
    flex: 1,
  },
  summaryLabel: {
    fontWeight: 'bold',
  },
  summaryText: {
    minHeight: 150,
    margin: 'auto',
    width: isBrowser || isTablet ? '60%' : '100%',
  },
  summaryNote: {
    color: colors.darkgrey,
    fontSize: 13,
  },
  transferButton: {
    marginLeft: 10,
  },
  transferIcon: {
    fontSize: 16,
  },
  wrapper: {
    margin: '0 auto',
    paddingBottom: 90,
    maxWidth: sizes.childScreen,
  },
  rowButton: {
    display: 'flex',
  },
  saveButton: {
    marginLeft: 4,
  },
  dummyBadge: {
    width: 'max-content',
    marginTop: 5,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}

ResidentEditForm.propTypes = {
  carers: PropTypes.array,
  deleteSelf: PropTypes.func.isRequired,
  features: PropTypes.object,
  zones: PropTypes.array,
}

const mapStateToProps = (state) => ({
  carers: state.data.carers,
  gps: state.data.gps,
  importantContacts: [],
  features: state.global.home,
  zones: state.data.zones,
  preferredPeopleNominative: state.global.home.preferredPeopleNominative,
  user: state.global.user,
})

const mapDispatchToProps = (dispatch) => ({
  clearFormArray: ({ key, indexes }) =>
    dispatch(
      Actions.clearFormArrayField({
        key,
        indexes,
        formId: FORM_ID,
      })
    ),
  deleteSelf: ({ id, onComplete }) =>
    dispatch(
      Operations.deleteFormItem({
        id,
        list: 'residents',
        onComplete,
      })
    ),
})

const wrappedForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResidentEditForm)

export default Form(wrappedForm, FORM_ID)
